module.exports = __webpack_public_path__ + "static/media/manual_de_usuario.cf84c24d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/manual_de_usuario.pdf
// module id = 303
// module chunks = 0